const truncate = (
    input: string | undefined,
    maxLength: number,
    separator = "…"
) => {
    if (typeof input !== "string") return "";
    if (input.length <= maxLength) return input;

    const separatorLength = separator.length;
    const maxLengthWithoutSeparator = maxLength - separatorLength;
    const startLength = Math.floor(maxLengthWithoutSeparator / 2);

    return (
        input.substring(0, startLength) +
        separator +
        input.substring(input.length - startLength)
    );
};

export { truncate };
